import { render } from "./tSdudyDesign.vue?vue&type=template&id=49dff3d6"
import script from "./tSdudyDesign.vue?vue&type=script&lang=js"
export * from "./tSdudyDesign.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__